import React, { useEffect, useState } from "react";
import apiClient from "../../../utils/apiClient";
import { useNavigate } from "react-router-dom";
import DashboardTitleComponent from "../../custom/DashboardTitleComponent";
import CustomSelectField from "../../custom/CustomSelectField";
import CustomButton from "../../custom/CustomButton";
import CustomDataGrid from "../../custom/CustomDataGrid";
import { MenuItem } from "@mui/material";

const vaActionTypes = [
	{
		id: "C",
		label: "Create"
	},
	{
		id: "I",
		label: "Insert"
	},
	{
		id: "U",
		label: "Update"
	},
	{
		id: "D",
		label: "Delete"
	},
]

const UploadVAReportMenu = () => {
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

	const [listPembayaranItems, setListPembayaranItems] = useState([]);

	const [jenisIuranTypeList, setJenisIuranTypeList] = useState([]);
	const [jenisIuranTypeSelected, setJenisIuranTypeSelected] = useState("");
	const [vaActionTypeSelected, setVaActionTypeSelected] = useState("");

  const navigate = useNavigate();

  const handleViewChanges = (userId) => {
    navigate(`/anggota/${userId}`);
  };

	useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiClient.get("/master-pembayaran-iuran");
        setListPembayaranItems(
          response.data.data.map((item) => ({
						id: item.id,
            uuid: item.uuid,
            name: item.name,
            biaya: item.biaya,
            vaCode: item.va_code
          }))
        );
      } catch (error) {
        alert("Error fetching payment options", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    apiClient
      .get("/users?member=1")
      .then((response) => {
        setRows(
          response.data.data
					.filter((user, index) => user.ktp && user.ktp.length === 16)
					.map((user, index) => ({
							userId: user.uuid,
							id: index + 1 + (page - 1) * 10,
							namaAnggota: user.nama_lengkap,
							noAnggota: user.id_users,
							provinsi: user.provinsi_institusi,
							role: user.role,
							idUsers: user.id_users,
							ktp: user.ktp
						}
					))
        );
        setRefresh(!refresh);
      })
      .catch((error) => {
        console.error("Error fetching member", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div>
			<DashboardTitleComponent text={"Pembuatan VA"} />
			<div
				style={{
					display: "flex",
					alignItems: "center",
					gap: "0 10px"
				}}
			>
				<CustomSelectField
					value={jenisIuranTypeSelected}
					placeholder={"Pilih Jenis Iuran"}
					onChange={(event) => {
						setJenisIuranTypeSelected(event.target.value);
					}}
					menuItems={listPembayaranItems.map((jenisIuran, index) => (
						<MenuItem key={index} value={jenisIuran.name}>
							{jenisIuran.name}
						</MenuItem>
					))}
				/>
				<CustomSelectField
					value={vaActionTypeSelected}
					placeholder={"Pilih Tipe Aksi"}
					onChange={(event) => {
						setVaActionTypeSelected(event.target.value);
					}}
					menuItems={vaActionTypes.map((type, index) => (
						<MenuItem key={index} value={type.id}>
							{type.label}
						</MenuItem>
					))}
				/>
				<CustomButton
					// onClick={handleOpenMasterModal}
					text="Download File Pembuatan VA"
					isFullWidth={false}
					baseColor="#003158"
					hoverColor="#00213A"
					width={280}
				/>
			</div>
			<div style={{ height: "20px" }}></div>
      <CustomDataGrid
        rows={rows}
        loading={loading}
        columns={[
          { field: "id", headerName: "No.", width: 100 },
          { field: "ktp", headerName: "NIK" },
          { field: "namaAnggota", headerName: "Nama Anggota" },
        ]}
        page={page}
        setPage={setPage}
      />
    </div>
  );
};

export default UploadVAReportMenu;
